module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec-5-63527be550530798fa7df313aa7ffaf1.jpg";